// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.98.0_@swc+core@1.7.1_@swc+helpers@0.5.5__/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.98.0_@swc+core@1.7.1_@swc+helpers@0.5.5__/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IeZGvagUgQJwi5jrl0Gh{font:var(--ui-small-medium)}.wuFWIzk3fta3nEZAIovT{margin-top:16px;font:var(--ui-medium-bold)}`, "",{"version":3,"sources":["webpack://./src/domains/ConsolidatedCheckout/RemoveFromCartModal/RemoveFromCartModal.module.scss"],"names":[],"mappings":"AAAA,sBACE,2BAAA,CAGF,sBACE,eAAA,CACA,0BAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContent": `IeZGvagUgQJwi5jrl0Gh`,
	"confirmSentence": `wuFWIzk3fta3nEZAIovT`
};
export default ___CSS_LOADER_EXPORT___;
